import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {DecimalPipe} from "@angular/common";
import {FormFieldGroupConfig} from "../../../../model/api/form-field-group-config";
import {BatchUpdateRequest} from "../../../../model/api/batch-update-request";
import {CcFormDialogComponent} from "../../../../crystal-elements/form-dialog/cc-form-dialog.component";
import {
  CustomerCustomerBatchFormConfigService
} from "../../../../services/customer/customer/customer-customer-batch-form-config.service";
import {CustomerCustomerService} from "../../../../services/customer/customer/customer-customer.service";
import {CustomerCustomerDataLoadingService} from "../../../../services/customer/customer/customer-customer-data-loading.service";
import {Customer} from "../../../../model/customer/customer";
import {ProgressTracker} from "../../../../model/api/progress-tracker";
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {Observable} from "rxjs";
import {ApiValidation} from "../../../../model/api/api-validation";

@Component({
  selector: 'app-batch-action-customer-form',
  templateUrl: './batch-action-customer-form.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
    DecimalPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BatchActionCustomerFormComponent extends CcBaseComponent {


  formLoading: boolean = false;

  formSubmitted: boolean = true;

  formConfig: FormFieldGroupConfig[] = [];

  dialogFormTitle: string = '';

  @Input()
  formRecord: Customer;
  originOwnerId: number;
  @Input()
  transPartKey: string;
  @Input()
  selectedRecords: Customer[] = [];
  @Input()
  dialogFormVisible: boolean = false;
  @Input()
  dataLoadingService: CustomerCustomerDataLoadingService
  @Input()
  tracker: ProgressTracker
  @Input()
  settingsFormLoadingProgressValue: number = 100;
  @Output()
  dialogFormVisibleChange = new EventEmitter<boolean>();

  @Output()
  onSavedForm = new EventEmitter<any>();

  @ViewChild('batchUpdateFormDialog')
  ccFormDialog: CcFormDialogComponent;

  @Input()
  action: "update" | "clone";

  constructor(cdref: ChangeDetectorRef,
              private confirmationService: ConfirmationService,
              private customerCustomerService: CustomerCustomerService,
              private formConfigService: CustomerCustomerBatchFormConfigService,
              messageService: MessageService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  protected initConfigs() {
    super.initConfigs();
    this.formConfig = this.formConfigService.loadConfig(this);
  }

  protected initData(): void {
    super.initData();
  }

  closeDialogForm(): void {
    this.dialogFormVisible = false;
    this.dialogFormVisibleChange.emit(false);
    this.markForCheck();
  }

  save() {
    this.formLoading = true;
    const batchUpdateRequest = new BatchUpdateRequest<Customer>();
    batchUpdateRequest.recordToApply = {...this.formRecord}
    batchUpdateRequest.recordIds = this.selectedRecords.map(value => value.id.toString());
    batchUpdateRequest.fieldToUpdate = [...this.formConfigService.fieldsToUpdate];

    this.getSaveAction(batchUpdateRequest).subscribe(validation => {
      if (validation.success) {
        this.formConfigService.fieldsToUpdate.splice(0)
        this.onSavedForm.emit(this.formRecord);
        this.closeDialogForm();
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }

  private getSaveAction(batchUpdateRequest: BatchUpdateRequest<Customer>): Observable<ApiValidation<any>> {
    if (this.action === "update") {
      return this.customerCustomerService.saveBatch(batchUpdateRequest);
    } else if (this.action === "clone") {
      return this.customerCustomerService.cloneBatch(batchUpdateRequest);
    } else {
      throw new Error("Unknown action: " + this.action);
    }
  }

  dialogFormVisibleChanged($event: boolean) {
    if ($event) {
      this.originOwnerId = this.formRecord.ownerId;
      this.formConfig = this.formConfigService.loadConfig(this);
    }

    this.dialogFormTitle = $event ? this.getTranslation('page.' + this.transPartKey + '.table.batch_' + this.action + '_button')
      + " " + this.selectedRecords.length + " " + this.getTranslation('page.' + this.transPartKey + '.item_name') + 's' : '';

    this.dialogFormVisibleChange.emit($event);
    this.formConfigService.fieldsToUpdate.splice(0);

    if(this.action == 'clone' ) {
      this.formConfigService.fieldsToUpdate.push('ownerId');
    }

    this.ccFormDialog.reloadFieldValueMap();
    setTimeout(() =>{
      this.formLoading = !$event;
      this.markForCheck();
    });
  }

  public confirmDialog(
    action: () => void,
    titleKey: string,
    messageKey: string,
    submitKey = 'common.dialog.ok',
    cancelKey = 'common.dialog.cancel',
  ): void {
    this.confirmationService.confirm({
      header: this.getTranslation(titleKey),
      message:
        this.getTranslation(messageKey),
      icon: 'fas fa-exclamation-triangle',
      acceptLabel: this.getTranslation(submitKey),
      rejectLabel: this.getTranslation(cancelKey),
      acceptButtonStyleClass: 'p-button-danger p-button-sm',
      rejectButtonStyleClass: 'p-button-warning p-button-sm',
      accept: () => action(),
    });
  }

}
